import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=5c2d9ee4&scoped=true&"
import script from "./Presentation.vue?vue&type=script&lang=js&"
export * from "./Presentation.vue?vue&type=script&lang=js&"
import style0 from "./Presentation.vue?vue&type=style&index=0&id=5c2d9ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d9ee4",
  null
  
)

export default component.exports